<template>
	<div id="common" style="background-color: #f2f2f2;">
		
		<el-container>
			<!-- 头部 -->
			<el-header style="height: 10rem;">
				<div class="header">
					<div class="header-div">
						<div class="left">
							<img src="../../../assets/shudo/images/u10.png" />
							<div class="div">
								<div class="div1">{{info.username}}</div>
								<div class="div2">
									<div>
										<img src="../../../assets/shudo/images/u21.png" />
										<span>{{info.nationality}}|{{info.city}}</span>
									</div> 
									<div>
										<img src="../../../assets/shudo/images/u20.png" />
										<span>{{info.label}}</span>
									</div>
								</div>
								<!-- <div class="div3">{{info.label}}</div> -->
							</div>
							
						</div>
						<!-- <div class="right">
							<div class="right3" v-if="types<=0" @click="visitorClick()">关注</div>
							<div class="right3" v-if="types>0" @click="visitorClick()" >已关注</div>
							<div class="right1">
								<div class="right2">
									<div>{{info.attention ? info.attention: 0 }}</div>
									<div>粉丝</div>
								</div>
								
								<div class="right2">
									<div>{{info.visitor ? info.visitor: 0 }}</div>
									
									<div>访客</div>
								</div>
							</div>
							
						</div> -->
					</div>
					<div class="tab">
						<div @click="url('/touser_gameall')" :class="type=='/touser_gameall' ? 'action':''">订阅赛事</div>
						<div  @click="url('/touser_question')" :class="type=='/touser_question' ? 'action':''">订阅题库</div>
						<div @click="url('/touser_tixing')" :class="type=='/touser_tixing' ? 'action':''">订阅题型</div>
					</div>
				</div>
			</el-header>  
			<div style="height: 1rem;"></div>
			<el-container style="width: 80%;  margin: auto; padding-bottom:6rem">
				
				<el-main>
					
					
					<router-view></router-view>   
				</el-main>
			</el-container>
		</el-container>
		
	</div>
	
	


</template>

<script>
	export default {
	    data() {
			return {
				type    :  '/touser_question',
				user_id : '',
				info    : [],
				types   : 0
			}
	    },
		created() {
			let that = this;
			var  query = that.$route.query;
			that.type  = this.$route.path;
			if(query.user_id){
				that.user_id = query.user_id;
				that.infoTpye();
				
				// that.$http('post','/api/v1/user/touser',{merchant_id:that.user_id,type:1}) .then(function (res) {
				// 	that.infoTpye();
				// });
			}
		},
		methods:{
			url(e){
				var url  = e+'?user_id='+this.user_id;
				
				this.$router.push(url);
				this.type = e;
				console.log(e)
			},
			visitorClick(){
				let that =this;
				that.$http('post','/api/v1/merchant/merchantuseradd',{merchant_id:that.merchanthot_id,type:0}) .then(function (res) {
					that.$message({message: res.msg,type: 'success'});
					that.infoTpye();
				});
			},
			infoTpye(){
				let that =this;
				that.$http('get','/api/v1/user/touser?user_id='+that.user_id,{}) .then(function (res) {
					that.info = res.data.info;
					console.log(that.info);
					// that.types = res.data.type;
				});
			}
		},
	}
	
</script>

<style lang="less">
	.el-header {
		height: 10rem;
		padding: 0;
	}
	.lefttype {
		color: #3d3e40 !important;
		font-size: 0.86rem !important;
	}
	.header {
		color: #FFFFFF;
		background-color: rgba(9, 7, 35, 1);
		width: 100%;
		height: 10rem;
		.header-div {
			width: 70%;
			margin: auto;
			display: flex;
			padding-top: 2rem;
			.left {
				flex: 2;
				display: flex;
				img {
					width: 5rem;
				}
				.div {
					padding-left: 1.6rem;
					.div1 {
						font-size: 1rem;
						font-weight: 600;
						padding-top: 1rem;
					}
					.div2 {
						padding-top: 0.6rem;
						font-size: 0.6rem;
						display: flex;
						div {
							
							img {
								width: 1rem;
								position: relative;
								top: 0.2rem;
							}
							span {
								padding-left: 0.4rem;
							}
						}
						div:nth-last-child(1){
							margin-left: 0.6rem;
						}
						
					}
					.div3 {
						position: relative;
						top: 1rem;
						font-size: 0.6rem;
					}
				}
				
			}
			.right {
				flex: 1;
				padding-top: 1.4rem;
				.right1 {
					padding-left: 1rem;
					display: flex;
					font-size: 0.6rem;
					.right2 {
						
						width: 2rem;
						text-align: center;
						line-height: 1.2rem;
					}
				}
				.right3 {
					position: relative;
					top: -0.5rem;
					left: 0.3rem;
					width: 5.4rem;
					text-align: center;
					height: 1.6rem;
					background-color: #FFFFFF;
					color: #000000;
					line-height: 1.6rem;
					border-radius: 0.4rem;
					font-size: 0.6rem;
				}
				
			}
		}
		.tab {
			display: flex;
			width: 50%;
			margin: auto;
			margin-top: 1rem;
			div {
				color: #A4A1A6;
				margin-left: 0.5rem;
				margin-right: 0.5rem;
				height: 1.4rem;
			}
			.action {
				border-bottom: 0.2rem solid rgba(217, 0, 27, 1);
			}
		}
	
	}
	.el-aside {
		margin-left: 1rem;
		height:23.5rem;
		div {
			
			font-size: 0.6rem;
			width: 100%;
			height: 2rem;
			line-height: 2rem;
			border-bottom: 1px solid #e9e9e9 ;
			color: #7F7F7F;
		}
	}
	
</style>
